export default "__VITE_ASSET__oqFgeyHn__"